export type Dest = 'PT' | 'PT-I' | 'ES' | 'EU' | 'BR'

export const DEST_FLAGS: Record<Dest, string> = {
  PT: '🇵🇹',
  'PT-I': '🇵🇹',
  ES: '🇪🇸',
  EU: '🌍',
  BR: '🇧🇷',
}

export const DEST_ALL: Dest[] = ['PT', 'PT-I', 'ES', 'EU', 'BR']
